/**
 * Format an audit log value record for display.
 *
 * Returns a compact human-readable string for common event shapes
 * (mapping events, user events) and falls back to JSON for the rest.
 */
export function formatAuditValue(value: Record<string, unknown> | null): string {
  if (value === null || value === undefined) return '—';

  // For mapping events, show a compact summary of the mappings
  if ('mappings' in value && Array.isArray(value.mappings)) {
    const mappings = value.mappings as Array<{ statusName?: string; internalStatus?: string }>;
    return mappings
      .map((m) => `${m.statusName ?? '?'} → ${m.internalStatus ?? '?'}`)
      .join(', ');
  }

  // For user events, show key fields
  if ('email' in value) {
    const parts: string[] = [];
    const email = typeof value.email === 'string' ? value.email : null;
    const role = typeof value.role === 'string' ? value.role : null;
    if (email) parts.push(email);
    if (role) parts.push(`role: ${role}`);
    return parts.join(', ') || JSON.stringify(value);
  }

  return JSON.stringify(value);
}
